import { stringify } from '../../versa/misc.js';
import { METHOD_CATEGORY_ORDER, getEndpointMethodCategory } from '../config/endpoint-method-groups.js';
import endpointFunctionGroups, { endpointMatchesFunctionGroup } from '../config/endpoint-function-groups.js';

export { endpointFunctionGroups, endpointMatchesFunctionGroup };

const compareByLabel = (a, b) =>
	String(a.name || '').localeCompare(String(b.name || ''), 'pt-BR', { sensitivity: 'base' })
	|| String(a.method || '').localeCompare(String(b.method || ''));

/**
 * Monta HTML de `<select>` com `<optgroup>` por categoria HTTP.
 * @param {object[]} endpoints
 * @param {import('../../versa/types/keymap.js').default} keymapField
 */
export function buildGroupedAvailableOptionsHtml(endpoints, keymapField)
{
	const buckets = Object.fromEntries(METHOD_CATEGORY_ORDER.map((c) => [c.id, []]));
	for (const ep of endpoints || [])
	{
		const cat = getEndpointMethodCategory(ep);
		(buckets[cat] ?? buckets.outros).push(ep);
	}
	const parts = [];
	for (const cat of METHOD_CATEGORY_ORDER)
	{
		const list = (buckets[cat.id] || []).sort(compareByLabel);
		if (!list.length)
			continue;
		parts.push(`<optgroup label="${cat.label}">`);
		for (const ep of list)
		{
			const value = stringify(keymapField._values.map((key) => ep[key]));
			const label = keymapField._labels.map((key) => ep[key]).join(' ');
			parts.push(`<option value="${value}">${label}</option>`);
		}
		parts.push('</optgroup>');
	}
	return parts.join('\n');
}

/**
 * @param {HTMLElement} availableSelect
 * @param {string} query
 */
export function filterGroupedAvailableSelect(availableSelect, query)
{
	const q = (query || '').toLowerCase().trim();
	availableSelect.querySelectorAll('optgroup').forEach((og) =>
	{
		let visible = 0;
		og.querySelectorAll('option').forEach((opt) =>
		{
			const show = !q || opt.textContent.toLowerCase().includes(q);
			opt.hidden = !show;
			if (show)
				visible++;
		});
		og.hidden = visible === 0;
	});
}

/**
 * Inclui no select de selecionados todos os endpoints de uma função ainda não atribuídos.
 * @returns {number} quantidade incluída
 */
export async function addFunctionGroupEndpoints({ db, keymapField, selectedSelect, functionGroup })
{
	const all = await db.list('endpoints') || [];
	const selected = new Set((keymapField.getValue() || []).map(String));
	const toAdd = all
		.filter((ep) => endpointMatchesFunctionGroup(ep, functionGroup) && !selected.has(String(ep.id)))
		.sort(compareByLabel);
	for (const ep of toAdd)
	{
		const html = await keymapField.makeOption(ep);
		if (html)
			selectedSelect.insertAdjacentHTML('beforeend', html);
	}
	if (toAdd.length)
		selectedSelect.dispatchEvent(new CustomEvent('move'));
	return toAdd.length;
}
